import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import FulcrumInput from 'components/fulcrum/input/Input' 
import NumberInput from 'components/fulcrum/input/NumberInput'
import HexInput from 'components/fulcrum/input/HexInput'
import Body from 'components/typography/body2/index'

import styles from '../styles.scss'


class DetailSelectionPage extends Component {
  textFieldRenderer = ({label, hint, property, required}) => {
    return (
      <Flex
        key={property}
        align='center'
        auto
        styleName='userInputContainer'
      >
        <div styleName='userInputHeader'>
          <Body>
            {label} {required ? <span styleName='required'>  *</span> : ''}
          </Body>
        </div>
        <div styleName='userInput'>
          <FulcrumInput 
            value={this.props.productDetails[property]}
            onChange={(value) => this.props.handleChange(property, value)}
            hint={hint}
          />
        </div>
      </Flex>
    )
  }

  numberFieldRenderer = ({label, hint, property, required}) => {
    return (
      <Flex
        key={property}
        align='center'
        auto
        styleName='userInputContainer'
      >
        <div styleName='userInputHeader'>
          <Body>
            {label} {required ? <span styleName='required'>  *</span> : ''}
          </Body>
        </div>
        <div styleName='userInput'>
          <NumberInput 
            value={this.props.productDetails[property]}
            onChange={(value) => this.props.handleChange(property, value)}
            hint={hint}
          />
        </div>
      </Flex>
    )
  }

  hexFieldRenderer = ({label, hint, property, required}) => {
    return (
      <Flex
        key={property}
        align='center'
        auto
        styleName='userInputContainer'
      >
        <div styleName='userInputHeader'>
          <Body>
            {label} {required ? <span styleName='required'>  *</span> : ''}
          </Body>
        </div>
        <div styleName='userInput'>
          <HexInput 
            value={this.props.productDetails[property]}
            onChange={(value) => this.props.handleChange(property, value)}
            hint={hint}
          />
        </div>
      </Flex>
    )
  }

  skuDetailsRenderer = () => {
    const textFields = [
      {label: 'GPU SKU', hint: 'Enter GPU SKU, E.g. GA104-300-A1', property: 'gpuSku', required: true},
      {label: 'Architecture', hint: 'Enter Architecture, E.g. Ampere', property: 'architecture', required: true},
      {label: 'Board SKU', hint: 'Enter Board SKU, E.g. PG190 SKU 30', property: 'boardSku', required: false}
    ]
    const numberFields = [
      {label: 'FB Width', hint: 'Input FB Width, E.g. 192', property: 'fbWidth', required: true}
    ]
    const hexFields = [
      {label: 'DevID', hint: 'Input DevID, E.g. 0x1C07', property: 'devid', required: true},
      {label: 'DevID B', hint: 'Input DevID B, E.g. 0x1D07', property: 'devid_b', required: false}
    ]
    
    return (
      <div>
        {textFields.map(field => this.textFieldRenderer(field))}
        {numberFields.map(field => this.numberFieldRenderer(field))}
        {hexFields.map(field => this.hexFieldRenderer(field))}
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <h5>Specify SKU Properties</h5>
        {this.skuDetailsRenderer()}
      </React.Fragment>
    )
  }
}

export default CSSModules(DetailSelectionPage, styles)
